import React from "react";

export interface RangeProps {
    title: string;
    value: number;
    onChange: (val: number) => void;
    step: number;
    min: number;
    max: number;
    unit: string;
    valMapper: (val: number) => number;
}

export const Range = (props: RangeProps) => {
    const [value, setValue] = React.useState<number>(props.value);

    return (
        <div className="mt-8 mb-8">
            <h2 className="text-sm font-medium text-gray-900">{props.title} - {props.valMapper(value)}{props.unit}</h2>
            <div className="relative">
                <label htmlFor="radius" className="sr-only">Labels range</label>
                <input id="radius" type="range" value={value} min={props.min} step={props.step} max={props.max}
                       onChange={(e) => setValue(Number(e.target.value))}
                       onMouseUp={() => props.onChange(value)}
                       onKeyUp={() => props.onChange(value)}
                       className="w-full h-2 accent-indigo-600 bg-gray-600 rounded-lg appearance-none cursor-pointer dark:bg-gray-600"/>
                <span
                    className="text-sm text-gray-500 dark:text-gray-400 absolute start-0 -bottom-6">Min ({props.valMapper(props.min)}{props.unit})</span>
                <span
                    className="text-sm text-gray-500 dark:text-gray-400 absolute end-0 -bottom-6">Max ({props.valMapper(props.max)}{props.unit})</span>
            </div>
        </div>
    )
}